// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file events/v1/subscription_failed.proto (package events.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file events/v1/subscription_failed.proto.
 */
export const file_events_v1_subscription_failed: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CiNldmVudHMvdjEvc3Vic2NyaXB0aW9uX2ZhaWxlZC5wcm90bxIJZXZlbnRzLnYxIikKElN1YnNjcmlwdGlvbkZhaWxlZBITCgtwbGFuX2hhbmRsZRgBIAEoCUJzCg1jb20uZXZlbnRzLnYxQhdTdWJzY3JpcHRpb25GYWlsZWRQcm90b1ABWgQuL3BiogIDRVhYqgIJRXZlbnRzLlYxygIJRXZlbnRzXFYx4gIVRXZlbnRzXFYxXEdQQk1ldGFkYXRh6gIKRXZlbnRzOjpWMWIGcHJvdG8z'
    );

/**
 * @generated from message events.v1.SubscriptionFailed
 */
export type SubscriptionFailed = Message<'events.v1.SubscriptionFailed'> & {
    /**
     * @generated from field: string plan_handle = 1;
     */
    planHandle: string;
};

/**
 * Describes the message events.v1.SubscriptionFailed.
 * Use `create(SubscriptionFailedSchema)` to create a new message.
 */
export const SubscriptionFailedSchema: GenMessage<SubscriptionFailed> =
    /*@__PURE__*/
    messageDesc(file_events_v1_subscription_failed, 0);
